
import { PropTypes } from 'prop-types';
import { retrunAssets } from '../../utils/getAssets';
const SpotLights = ({ events }) => {

    const img = events?.opinionArticlesImage != null ? retrunAssets(events?.opinionArticlesImage[0].url) : "/assets/spotLight.svg"
    const description = events?.bulletinDescription
    const items = events?.bulletinDownload?.items?.map((item) => {
        item = item?.content?.properties
        return (
            {
                title: item?.bulletinDownloadLabel || item?.label,
                url: item?.bulletinDownload != null ? retrunAssets(item?.bulletinDownload[0]?.url) : item?.link
            }
        )
    })



    return (
        <div className="flex-col justify-start items-start inline-flex">
            <img className="w-full relative" src={img} />
            <div className="h-72 flex-col justify-start items-start gap-2.5 flex">
                <div className="w-full h-28 text-justify text-zinc-800 text-sm font-normal  leading-tight tracking-tight">{description}</div>
                <div className="w-full h-12 flex items-center flex-wrap justify-between gap-4">
                    {
                        items?.map((item, index) => {
                            return (
                                <a key={index} href={item.url} download={item?.url} target="_blank" rel='noreferrer' className="text-cyan-600 shrink-0 text-sm font-bold hover:underline">{item.title}</a>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
SpotLights.propTypes = {
    events: PropTypes.object
}
export default SpotLights